export default Object.freeze({
  None: 1,
  Web: 2,
  Telegram: 3,
  OpenAI: 4,
});
